import Vue from "vue";
import _ from "lodash";

const types = {
    SET_IMAGE_MODAL: "SET_IMAGE_MODAL",
};

const state = {
    imagen: false,
};

const actions = {
    setModalImagen({ commit, dispatch }, data) {
        commit(types.SET_IMAGE_MODAL, data);
    },
}

const mutations = {
    [types.SET_IMAGE_MODAL](state, data) {
        state.imagen = data;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
